export * as queries from './queries';
export * as mutations from './mutations';
export const BASE_PATH = 'custom-program';
export const NEW_BASE_PATH = 'custom-programs';
